import { Button, Card, Col, DatePicker, Form, Row, Skeleton, Space, Table } from 'antd'
import moment from 'moment';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';
import { FilePdfOutlined, SearchOutlined } from '@ant-design/icons';
import _ from 'lodash';

export default function UserWiseTransaction(props) {

    const userWiseTran = useStoreState((state) => state.ledger.userWiseTran);
    const fetchuserWiseTran = useStoreActions((state) => state.ledger.fetchuserWiseTran);
    const loading = useStoreState((state) =>  state.ledger.loading);

    const [reportForm] = Form.useForm();

    const reportFormSubmit = (value) => {
        let postData = {
            fromDate: moment(value?.fromDate).format("YYYY-MM-DD"),
            toDate: moment(value?.toDate).format("YYYY-MM-DD")
        }

        fetchuserWiseTran(postData);
    };

    const [data, setData] = useState<any>([]);

    useEffect(() => {
        let temp = _.orderBy(userWiseTran, 'userName', 'desc');
        setData(temp);
    }, [userWiseTran])


    let sameKey;
    const columns = [
        {
            title: "User",
            dataIndex: "userName",
            key: "userName",
            render: (value, row, index) => {

                const obj: any = {
                    children: value,
                    props: {}
                };
                if (!(sameKey !== value)) {
                    obj.props.rowSpan = 0;
                    return obj;
                }
                const count = data.filter(item => item.userName === value).length;
                sameKey = value;
                obj.props.rowSpan = count;
                return obj;
            }
        },
        {
            title: "Details",
            children: [
                {
                    title: "Ledger Name",
                    dataIndex: "ledgerName",
                    key: 1
                },
                {
                    title: "Debit",
                    dataIndex: "debit",
                    key: 2
                },
                {
                    title: "Credit",
                    dataIndex: "credit",
                    key: 3
                }
            ]
        }
    ];



    return (
        <>
            <Card title="User Wise Transaction Overview" >
                <Form
                    layout="vertical"
                    onFinish={reportFormSubmit}
                    id="basic-info"
                    form={reportForm}
                >
                    <Row gutter={8}>
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}> </Col>
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                            <Form.Item
                                name="fromDate"
                                label="From Date"
                                className="title-Text"
                                rules={[
                                    { required: true, message: "Please enter from date" },
                                ]}
                            >

                                <DatePicker style={{ width: '100%' }} placeholder="Select Date" format={"DD/MM/YYYY"} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                            <Form.Item
                                name="toDate"
                                label="To Date"
                                className="title-Text"
                                rules={[
                                    { required: true, message: "Please enter to date" },
                                ]}
                            >

                                <DatePicker style={{ width: '100%' }} placeholder="Select Date" format={"DD/MM/YYYY"} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={2} xl={2}>
                            <Space size="small" >
                                <Button type="primary" htmlType="submit" style={{ height: 40 }} icon={<SearchOutlined />}>
                                    Search
                                </Button>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={4} xl={4}> </Col>
                    </Row>
                </Form>
                < Skeleton loading={loading} paragraph ={{rows:10}} />
                {userWiseTran?.length > 0 &&
                    <>
                    
                        <Table
                            columns={columns}
                            dataSource={data?.map((d, i) => ({ key: i, ...d }))}
                            pagination={false}
                            bordered={true}
                        />

                    </>
                }
            </Card>
        </>
    )
}
